import { forwardRef } from "react";
import { Link } from "react-router-dom";
import type { LinkProps } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageProvider";

/**
 * Drop-in replacement for react-router's <Link> that keeps the visitor inside
 * the current language (adds the /he prefix on Hebrew routes).
 */
const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...props }, ref) => {
  const { lp } = useLanguage();
  const target = typeof to === "string" ? lp(to) : to;

  return <Link ref={ref} to={target} {...props} />;
});

LocalizedLink.displayName = "LocalizedLink";

export default LocalizedLink;
